import type { Routes } from '@angular/router';

import { EToolsTab } from './tools.const';

export const TOOLS_DEFAULT_ROUTE = EToolsTab.AI_MODELS;

export const TOOLS_CHILD_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: TOOLS_DEFAULT_ROUTE,
  },
  {
    path: EToolsTab.AI_MODELS,
    loadComponent: () =>
      import('../components/models-catalog-wrapper/models-catalog-wrapper.component').then((m) => m.ModelsCatalogWrapperComponent),
  },
  {
    path: EToolsTab.PROMPTS,
    loadComponent: () =>
      import('../components/prompts-catalog-wrapper/prompts-catalog-wrapper.component').then((m) => m.PromptsCatalogWrapperComponent),
  },
  {
    path: EToolsTab.EXTENSIONS,
    loadComponent: () =>
      import('../components/extensions-catalog-wrapper/extensions-catalog-wrapper.component').then(
        (m) => m.ExtensionsCatalogWrapperComponent,
      ),
  },
];
